import { createContext, useContext } from "react";

export const FormFlowContext = createContext();

export const useFormFlowContext = () => {
  return useContext(FormFlowContext);
};
